import React, { useState } from 'react';
import { Event } from './Events/Event';
import styled from 'styled-components';
import { HorizontalGroup, Icon } from '@libs/uikit/Components';
import { TrackedUrlEvents } from './Events/TrackedUrlEvents';

const ConsoleWrapper = styled.div`
    color: #2b2b2b;
`;

const ConsoleHeader = styled(HorizontalGroup)`
    font-size: 12px;
    border-radius: 4px;
    background-color: #80ccff;
    padding: 8px 16px 8px 16px;

    & div:nth-child(1) {
        flex: 1;
    }

    & div:nth-child(2) {
        flex: 1;
    }

    & div:nth-child(3) {
        flex: 6;
    }
`;

const ConsoleMain = styled.div`
    height: 300px;
    margin: 0 0 10px 0;
    overflow-y: auto;
    border-bottom: 1px solid #dcdcdc;
`;

const ConsoleTotal = styled(HorizontalGroup)`
    background-color: #e9ebec;
    border-radius: 4px;
    font-size: 12px;
    padding: 8px 16px 8px 16px;
`;

const isEmpty = (arr) => (arr || []).length === 0;

const FilterWrapper = styled(HorizontalGroup)`
    border-bottom: 1px solid #e9ebec;
`;
const FilterItem = styled.div`
    padding: 6px;
    font-size: 12px;
    color: #2e2e2e;
    cursor: pointer;
    border-bottom: ${({ active }) => (active ? '3px solid #e9ebec' : 'none')};
`;

export const Console = ({ events = [], system, hasProblem = false }) => {
    const [current, setCurrent] = useState('ALL');
    const filteredEvents = events.filter((event) => {
        if (current === 'ALL' && system === 'Google') {
            return true;
        }
        const { type } = event;
        const types = {
            onEventOmid: 'OMID',
            onEventGeneral: 'General',
            onEventVast: 'VAST',
            onEventVpaid: 'VPAID',
        };
        if (current === 'ALL') {
            return Boolean(types[type.replace(/_/g, ' ').split('/')[1]]);
        }
        const typeName = system === 'LoopMe' ? types[type.replace(/_/g, ' ').split('/')[1]] : type;
        if (!typeName) {
            return false;
        }
        if (typeName === current) {
            return true;
        }
    });
    const Events = ({ events }) => {
        return events.map((event, key) => <Event key={key} event={event} system={system} current={current} />);
    };

    const trackedUrls = events
        .filter(({ payload }) => payload?.trackedUrls?.urls)
        .map(({ payload, timestamp }) => ({ ...payload?.trackedUrls, timestamp }));

    return (
        <ConsoleWrapper>
            <FilterWrapper>
                <FilterItem onClick={() => setCurrent('ALL')} active={current === 'ALL'}>
                    All
                </FilterItem>
                {system === 'LoopMe' && (
                    <>
                        <FilterItem onClick={() => setCurrent('VAST')} active={current === 'VAST'}>
                            VAST
                        </FilterItem>
                        <FilterItem onClick={() => setCurrent('VPAID')} active={current === 'VPAID'}>
                            VPAID
                        </FilterItem>
                        <FilterItem onClick={() => setCurrent('OMID')} active={current === 'OMID'}>
                            OMID
                        </FilterItem>
                        <FilterItem onClick={() => setCurrent('TRACKED_URLS')} active={current === 'TRACKED_URLS'}>
                            Tracked Urls
                        </FilterItem>
                    </>
                )}
            </FilterWrapper>
            {current === 'TRACKED_URLS' ? (
                <>
                    <ConsoleHeader>
                        <div>Time</div>
                        <div>Event Name</div>
                        <div>Tracked url</div>
                    </ConsoleHeader>
                    <ConsoleMain>
                        <TrackedUrlEvents events={trackedUrls} />
                    </ConsoleMain>
                </>
            ) : (
                <>
                    <ConsoleHeader>
                        <div>Time</div>
                        <div>Type</div>
                        <div>Event Name</div>
                    </ConsoleHeader>
                    <ConsoleMain>
                        <Events events={filteredEvents} />
                    </ConsoleMain>
                </>
            )}

            <ConsoleTotal>
                <div style={{ flex: 1 }}>Total events: {filteredEvents.length}</div>
                {hasProblem ? (
                    <Icon name="wiz_warning" style={{ color: 'red' }} />
                ) : (
                    <Icon name="success" style={{ color: '#0a9393' }} />
                )}
            </ConsoleTotal>
        </ConsoleWrapper>
    );
};
